import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates after `value` has
 * stopped changing for `delayMs`. Used to keep server-backed list searches
 * from firing one request per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
